import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectCompact, Radium } from 'higher-order-components'
import { InlineDisclaimerBlock, FixedBar } from 'containers'
import { Button, LoaderIcon } from 'components'
import { noop } from 'utils'
import { invokeFuncs } from 'utils/function'
import { A, H6, Interactive, Caption, AddressIcon } from 'AtomicComponents'

const CarOutline = () => (
  <svg
    data-test="car-outline"
    viewBox="0 0 111 54"
    style={{ height: '3em', margin: 'auto 1em auto 0', fill: '#DBDBDB' }}>
    <path d="M110.88,24.73a6.66,6.66,0,0,0-.16-1.07c-0.22-1.8-1-3.56-1.2-5.34-0.26-.61.63-4.7-1.15-4.31a44.53,44.53,0,0,1-3.88-2.66c-1.16-1-2.2-2.19-3.27-3.31-1.36-.9-2.31-2.18-3.51-3a27.75,27.75,0,0,0-4.58-2.77A44.4,44.4,0,0,0,86.52.56C85.32,0.39,83.9.4,82.58,0.29,79,0,75.64,0,72,0S64.74,0.2,61.12.4c-2.42.13-4.89,0.73-7.28,0.73a16.47,16.47,0,0,0-2.18.26,17.86,17.86,0,0,0-3.55.51C47.88,2,47,2.22,46.26,2.49h0A17.57,17.57,0,0,0,44,3.37l-0.1.05a17.25,17.25,0,0,0-1.72.9L41,5c-0.34.17-.72,0.37-1.09,0.57h0a7.44,7.44,0,0,0-.82.52L36.28,7.8l0,0a22.11,22.11,0,0,0-2.11,1.63c-0.4.15-2.8,1.89-2.84,1.91h0c-0.3.17-.59,0.34-0.89,0.53a2.85,2.85,0,0,0-.92.48,5.58,5.58,0,0,0-.3,1,1.45,1.45,0,0,1-.61.4,9,9,0,0,1-3.53.82,50,50,0,0,0-10,2.29,24,24,0,0,0-3.37,1.37c-1.15.6-2.12,1.45-3.24,2-0.4.2-4.4,2.14-5.45,2.83H3l-0.42.19-0.23.18h0A4.06,4.06,0,0,0,2,26.76c0.22,0.22-.93,1.48-1,1.62-0.48.79-.93,6.27-1,7.51a12.56,12.56,0,0,0,.24,2.67c0.17,1.23-.29,2.53,0,3.74a6.64,6.64,0,0,0,.63,1c0,0.8,2.08,1.94,2.67,2.26,0.92,0.5.93,0.16,1.84,0.22a4.6,4.6,0,0,1,1.34.7c0.61,0.23,1.32,0,1.91.18a1.26,1.26,0,0,1,.44.28,8.39,8.39,0,0,0,12.72.33,2.84,2.84,0,0,1,1.36-.17c1.42,0,26.27,1.14,30,1.48a7.19,7.19,0,0,1,1.67.45,2.28,2.28,0,0,1,.81,0,4.49,4.49,0,0,1,.75,1.09,6.25,6.25,0,0,0,1.74,1.68A7.71,7.71,0,0,0,59.62,53a8,8,0,0,0,8,0l0.1,0a2.17,2.17,0,0,0,.31-0.2,9.15,9.15,0,0,0,4.24-7,1.74,1.74,0,0,1,.66-0.94c0.85-.54,22.59-5,23.44-5.09,0,0,1.22,0,1.25,0a1.59,1.59,0,0,0,0,.83,4.52,4.52,0,0,0,.5.29c0.12,0.12.23,0.33,0.41,0.52,0.87,0.89,1.3,1.56,2.63,1.77,1.69,0.27,4.7.54,6-.79,1.59-1.64,1.85-4.18,2.22-6.42,0.19-1.15.81-2.11,1-3.33a13.51,13.51,0,0,0,.34-2.57C110.74,28.22,111.22,26.46,110.88,24.73Z" />
  </svg>
)

export const PostcodeIcon = ({ fill }) => (
  /* width: 2em for IE */
  <svg viewBox="0 0 26 36" style={{ height: '100%', width: '2em', fill }}>
    <path
      d="M26 12.98c0 5.72-2.98 10-6 14-1.62 2.12-5.74 7.38-5.74 7.38L13 36l-1.24-1.6S7.62 29.14 6 27.02c-3.04-4-6-8.3-6-14C-.011 5.84 5.8.011 12.98 0 20.16-.011 25.989 5.8 26 12.98zm-8.8-1.3h-.08A4.12 4.12 0 0 0 13 7.58a4.12 4.12 0 1 0 4.2 4.1z"
      fillRule="nonzero" />
  </svg>
)

PostcodeIcon.propTypes = {
  fill: PropTypes.string
}

const Pencil = () => (
  <svg viewBox="0 0 14 14" style={{ height: '1em', width: '1em', marginLeft: "1em", fill: '#910A2D' }}>
    <path d="M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z" />
  </svg>
)

const Info = () => (
  <svg width="17" height="17" viewBox="0 0 17 17">
    <g fill="none" fillRule="evenodd">
      <circle fill="currentColor" cx="8.5" cy="8.5" r="8.5" />
      <path
        d="M11.419 5.909c0-1.528-1.215-2.33-2.994-2.33-1.303 0-2.343.576-3.057 1.29l.84.99c.626-.602 1.252-.977 2.18-.977 1.077 0 1.69.4 1.69 1.102 0 .601-.288.89-.927 1.24-1.39.764-1.653 1.265-1.653 2.73h1.365c0-.951.126-1.252.94-1.703 1.052-.588 1.616-1.127 1.616-2.342zm-2.305 6.67a.957.957 0 0 0-.94-.953.957.957 0 0 0-.94.952c0 .514.427.94.94.94.514 0 .94-.426.94-.94z"
        fill="#FFF" />
    </g>
  </svg>
)

const NavButton = Radium(class extends Component {
    static propTypes = {
      dataTest: PropTypes.string,
      onClick: PropTypes.func,
      href: PropTypes.string,
      selectionLabel: PropTypes.string,
      selectedText: PropTypes.string,
      fallbackText: PropTypes.string,
      image: PropTypes.node,
      disabled: PropTypes.bool,
      active: PropTypes.bool
    }
    handleClick = (e) => {
      const { gtmEvents, onClick } = this.props
      e && e.stopPropagation()
      if (gtmEvents) invokeFuncs(gtmEvents)
      if (onClick) onClick(e)
    }
    render() {
      const {
        disabled,
        active,
        dataTest = '',
        selectionLabel = '',
        selectedText = '',
        fallbackText = '',
        href = null,
        image
      } = this.props
      return (
        <A
          withoutStyle
          data-test={dataTest}
          onClick={!disabled ? this.handleClick : null}
          href={!disabled ? href : null}>
          <div style={{ display: 'flex' }}>
            {image}
            <div style={styles.selectionWrapper}>
              <div
                style={[
                  styles.text,
                  styles.secondaryText,
                  { display: 'flex' }
                ]}>
                <Interactive>{selectionLabel}</Interactive>
                {!disabled && selectedText && <Pencil />}
                {!disabled &&
                  selectedText && (
                    <Interactive>
                    <span style={{ color: '#910A2D', marginLeft: "8px"}}>Edit</span>
                    </Interactive>
                  )}
              </div>
              <H6 withDetails>
                {selectedText || fallbackText}
              </H6>
            </div>
          </div>
        </A>
      )
    }
})

const renderError = (error) => {
  if (error) {
    return (
      <div
        style={{
          margin: '0',
          flex: '1 1 auto',
          textAlign: 'center'
        }}>
        {error}
      </div>
    )
  }
}

const NavigationBar = ({
  nameplateButton = {},
  dealerButton = {},
  showLoader = false,
  error,
  onNextStep = noop,
  backButton,
  nextButton = false,
  hint = false,
  innerRef = noop,
  compact = [true, true],
  step,
  gtmEvents
}) => (
  <FixedBar innerRef={innerRef}>
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {compact[1] && renderError(error)}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div
          style={{
              display: 'flex',
              listStyleType: 'none',
              padding: '.5em 1em',
              alignItems: 'center'
            }}>
          <NavButton
            {...dealerButton}
            dataTest={'select-dealer'}
            image={!compact[0] &&
              <AddressIcon
                style={{
                  width: "35px",
                  height: "42px",
                  margin: "auto 8px auto 16px",
                  fill: !dealerButton.selectedText ? '#999999' : '#910A2D'
                }}
              />
            }
            gtmEvents={gtmEvents.editDealer} />
          <div
            style={{
                borderLeft: '1px solid #E7E7E7',
                height: '3em',
                margin: compact[0] ? '0 1em' : '0 1em 0 2em'
              }} />
          <NavButton
            {...nameplateButton}
            dataTest={'select-nameplate'}
            image={
                !compact[0] &&
                (nameplateButton.image ? (
                  <img
                    style={{
                      width: 'auto', // height and negative padding to keep the component height as 3em
                      height: '4em',
                      margin: '-0.5em 1em -0.5em 0'
                    }}
                    src={nameplateButton.image} />
                ) : (
                  <CarOutline />
                ))
              }
            gtmEvents={gtmEvents.editNameplate} />
        </div>
        {!compact[1] && renderError(error)}
        {!compact[1] && showLoader && step === 'SELECT_NAMEPLATE' ? (
          <div
            style={{ margin: '0 2em' } // in show results step we have a loader in the main page already so this should be disabled
              }>
            <LoaderIcon />
          </div>
          ) : (
            <div style={{ display: 'flex', paddingRight: "2em" }}>
              {backButton && (
                <Button
                  {...backButton}
                  styleName="blackOutlined"
                  display="inline"
                  gtmEvents={gtmEvents.selectBack} />
              )}
              <div style={{width: '10px'}}></div>
              {nextButton && (
                <Button
                  {...nextButton}
                  disabled={!!error || nextButton.disabled}
                  display="inline"
                  styleName="red"
                  gtmEvents={gtmEvents.selectNext} />
              )}
            </div>
          )}
        {!compact[0] &&
            hint && (
              <div style={{ textAlign: 'left', margin: '0 2em' }}>
                <InlineDisclaimerBlock
                  message={hint.disclaimer}
                  yOffset={-6}
                  isIdentifierHidden
                  isIdentifierHiddenInPopUp
                  gtmEvents={hint.gtmEvents}>
                  <div
                    style={{
                      display: 'flex',
                      color: '#999999',
                      fontWeight: '200',
                      cursor: 'pointer',
                      alignItems: 'center',
                      transition: 'color .25s',
                      ':hover': { color: '#191919' }
                    }}>
                    <Info />
                    <span style={{ marginLeft: '.5em' }}>{hint.label}</span>
                  </div>
                </InlineDisclaimerBlock>
              </div>
            )}
      </div>
    </div>
  </FixedBar>
)

const styles = {
  navItem: {
    transition: 'opacity .25s',
    margin: '0 1em',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textDecoration: 'inherit',
    color: 'inherit'
  },
  text: {
    textTransform: 'uppercase',
    margin: 0,
  },
  secondaryText: {
    color: '#999999',
  },
  primaryText: {
    fontSize: '100%',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  selectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '41vw',
    '@media (min-width: 768px)': {
      maxWidth: '25vw'
    },
    '@media (min-width: 1100px)': {
      maxWidth: '35vw'
    }
  }
}

NavigationBar.propTypes = {
  onNextStep: PropTypes.func,
  showLoader: PropTypes.bool,
  hint: PropTypes.object,
  error: PropTypes.node,
  nameplateButton: PropTypes.object,
  dealerButton: PropTypes.object,
  backButton: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  nextButton: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  innerRef: PropTypes.func,
  compact: PropTypes.array,
  step: PropTypes.string,
  gtmEvents: PropTypes.shape({
    editNameplate: PropTypes.array,
    editDealer: PropTypes.array,
    selectNext: PropTypes.array,
    selectBack: PropTypes.array,
    disclaimer: PropTypes.array
  })
}

export default withRadium(DetectCompact({ threshold: [768, 1400] }))(NavigationBar)



// WEBPACK FOOTER //
// ./src/containers/outlet-store/navigation-bar.jsx